export default function Logo({ className }: ClassNameProps) {
    return <img src={'/images/logo_prod.png'} alt='Logo Campus Agenda' className={className} />;
}